import { render, staticRenderFns } from "./examPlan.vue?vue&type=template&id=95aa3a1a&scoped=true"
import script from "./examPlan.vue?vue&type=script&lang=js"
export * from "./examPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa3a1a",
  null
  
)

export default component.exports